import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useNewsLetterSignUpStateManager = () => {
  const {open, isOpen, cancel, hide} = useOpenedStateManager(
    'notification-center-newsletter-sign-up',
  );
  return {open, isOpen, cancel, hide};
};
